import { ProductionNetworkService } from "./ProductionNetworkService";

// TODO um... refactor me please
function getNetworkService() {
  return ProductionNetworkService;
}

export const NetworkService = getNetworkService();
